import {
    ChangeDetectionStrategy,
    Component, EventEmitter,
    Input,
    OnInit, Output
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AudioService } from '../services/audio.service';
import {
    callScripts,
    soundSoundIdURL,
    soundTTSUrl,
    TwilioVoiceParameterModel
} from './twilio-voice-parameter/twilio-voice-parameter.model';

@Component({
    selector: 'twilio-voice',
    templateUrl: './twilio-voice.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TwilioVoiceComponent implements OnInit {

    @Input() content;
    @Input() updatedModel;
    @Input() isOnlyPreview;
    @Input() contextVariables;
    @Input() communicationsCategoryId;
    @Output() readonly voiceChange: EventEmitter<any> = new EventEmitter<any>();
    @Output() readonly selectedNodeChange: EventEmitter<any> = new EventEmitter<any>();
    callScripts = {};
    twilioVoice: TwilioVoiceParameterModel[] = [];
    twilioVoiceParameter: TwilioVoiceParameterModel[] = [];
    twilioVoiceParameterVoiceMail = [];
    twilioVoiceParameterLanguage = [];
    isPlaying = false;
    isVoiceMail = false;
    isPlayAll = false;
    subscription = new Subscription();
    playSequence = -1;
    containsMoreThanOneLanguage = false;
    selectedLanguage = 'EN';

    playAll(sequenceNumber): void {
        this.playSequence = 0;
        this.isPlayAll = true;
    }

    stop(): void {
        this.playSequence = -1;
        this.isPlayAll = false;
    }

    isEnded(): void {
        if (this.isPlayAll) {
            this.playSequence++;
            if (this.playSequence >= this.twilioVoice.length) {
                this.stop();
            }
        }
    }

    showVoiceMail(): void {
        this.isVoiceMail  =  !this.isVoiceMail;
        this.twilioVoice = this.isVoiceMail ? this.twilioVoiceParameterVoiceMail : this.twilioVoiceParameter;
    }

    changeLanguage(): void {
        this.selectedLanguage  =  this.selectedLanguage === 'EN' ? 'ES' : 'EN';
        this.twilioVoice = this.selectedLanguage === 'EN' ? this.twilioVoiceParameter : this.twilioVoiceParameterLanguage;
    }

    ngOnInit(): void {
        this.callScripts = {...callScripts};
        this.containsMoreThanOneLanguage =  this.content.indexOf('ES') !== -1;
        if (this.communicationsCategoryId === 'reminder') {
            const handleScript = this.callScripts['handleScriptReminder'];
            this.setTwilioVoiceParameters(handleScript);
        } else {
            const handleScript = this.callScripts['handleScriptCommunication'];
            this.setTwilioVoiceParameters(handleScript);
        }
    }

    setTwilioVoiceParameters(handleScript): void {
        const skipPrompts: Array<string> = ['companyIntro2TTS', 'regarding2TTS', 'regarding3TTS', 'locationTTS', 'location2TTS',
                                            'companyOutro2TTS', 'regardingVoicemail2TTS', 'regardingVoicemail3TTS'];

        const matches = this.content.match(/(<Parameter[^>]*>)([^<]*|\n)*?(<\/Parameter>)/g);
        let i = 0;
        if (matches !== 0 && matches !== null) {
            while (i !== matches.length) {
                const value: TwilioVoiceParameterModel = {
                    name: undefined,
                    type: undefined,
                    src: undefined,
                    containsAppointment: '',
                    isAppointment: false,
                    audioService: new AudioService(),
                    canPreview: false,
                    model: undefined,
                    ttsMessage: undefined
                };

                value.type = this.extractValue('type', matches[i], /(type="([^"]|"")*")/g);
                if (value.type === 'tts') {
                    value.name = this.extractValue('name', matches[i], /(name="([^"]|"")*")/g);
                    // Check for all languages
                    const selectedKey = Object.keys(handleScript)
                        .find(key => key === value.name || `${key}ES` === value.name);
                    if (selectedKey !== undefined) {
                        const selectedValue = handleScript[selectedKey];
                        if (value.type !== selectedValue['type']) {
                            if (selectedValue['type'] === 'tts') {
                                value.type = 'tts';
                            }
                        }

                        if (value.type === 'tts') {
                            this.extractModelAndText(value, selectedValue);
                            const textToSpeech = this.extractContextVariable(value);
                            value.src = `${soundTTSUrl}${textToSpeech}`;
                            value.canPreview = true;
                        }

                        debugger;
                        const isNameInSkipPrompts = skipPrompts.includes(value.name);
                        if (!isNameInSkipPrompts || (isNameInSkipPrompts && value.ttsMessage !== '')) {

                            if (selectedValue['isForNormal'] && value.canPreview) {
                                if (value.name.indexOf('ES') === -1) {
                                    this.twilioVoiceParameter.push(value);
                                    if (value.name === 'companyIntro' ||
                                        value.name === 'companyIntro2' ||
                                        value.name === 'press1spanish') {
                                        this.twilioVoiceParameterLanguage.push(value);
                                    }
                                } else {
                                    this.twilioVoiceParameterLanguage.push(value);
                                }
                            }
                        }

                        if (selectedValue['isForVoicemail'] && value.canPreview) {
                            this.twilioVoiceParameterVoiceMail.push(value);
                        }
                    }
                }
                i++;
            }
        }

        this.twilioVoice = this.twilioVoiceParameter;
    }

    extractValue(key, value, regex): string {
        const match = value.match(regex);
        if (match !== null) {
            return match[0]
                .replace(`${key}="`, '')
                .replace('"', '');
        }

        return '';
    }

    extractModelAndText(value, selectedValue): any {
        Object.entries(this.updatedModel)
            .map((model: any) => {
                if (model[0].toLowerCase()
                    .indexOf(value.name.toLowerCase()) !== -1) {

                    value.model = selectedValue['model'] !== undefined ? selectedValue['model'] : `template.${model[0]}`;
                    value.ttsMessage = model[1];
                }
        });

        // case when the selected voice tag is not present in updatedmodel
        if (value.model === undefined && selectedValue['model'] !== undefined) {
            value.model = selectedValue['model'];
            value.ttsMessage = '';
        }

        return value;
    }

    extractContextVariable(value): any {
        Object.entries(this.contextVariables)
            .map(variable => {
                if (variable[0].toLowerCase()
                    .indexOf(value.name.toLowerCase()) !== -1) {

                    return variable[1];
                }
            });

        return undefined;
    }
}
